export const teamKeys = {
  all: ['org', 'team'] as const,
  members: () => [...teamKeys.all, 'members'] as const,
  effective: (id: string) => [...teamKeys.members(), id, 'effective-permissions'] as const,
  roles: () => [...teamKeys.all, 'roles'] as const,
};
